import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NotButton } from '@nebalkon-workspace/ui-kit';
import { StaffOrderDetailFacade } from './staff-order-detail.facade';

@Component({
  selector: 'lib-staff-order-detail-key-info',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, DatePipe, NotButton],
  templateUrl: './staff-order-detail-key-info.component.html',
  styleUrl: './staff-order-detail-key-info.component.scss',
})
export class StaffOrderDetailKeyInfoComponent {
  readonly facade = inject(StaffOrderDetailFacade);
}
